// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"3e7d9cc1","853":"80d54393"}[chunkId] + ".chunk.js";
};